export const getConfirmButtonLabel = (
  isDelivery: boolean,
  hasAvailableRestaurant: boolean,
  formatMessage: (params: { id: string }) => string
): string | undefined => {
  if (isDelivery) {
    return formatMessage({ id: 'restaurantClosedDialogButtonDelivery' });
  }

  if (hasAvailableRestaurant) {
    return formatMessage({ id: 'restaurantClosedDialogButton' });
  }

  return undefined;
};

export const getDialogBody = (
  isDelivery: boolean,
  hasAvailableRestaurant: boolean,
  formatMessage: (params: { id: string }) => string
): string => {
  if (isDelivery) {
    return formatMessage({ id: 'restaurantClosedDialogBodyDelivery' });
  }

  if (hasAvailableRestaurant) {
    return formatMessage({ id: 'restaurantClosedDialogBodyClosestOptionAvailable' });
  }

  return formatMessage({ id: 'restaurantClosedDialogBody' });
};
